import React from 'react';
import { Button } from './ui/Button';
import { FileText, Clock, Calendar, CheckCircle2, Package } from 'lucide-react';
export function Hero() {
  return <section className="pt-16 pb-12 px-4 md:pt-24 md:pb-16 max-w-4xl mx-auto text-center" data-id="element-120">
      <div className="inline-block bg-surface2 border border-zinc-800 rounded-full px-4 py-1.5 text-sm font-medium text-zinc-300 mb-6" data-id="element-121">
        El sistema N°1 para profes de E. Funcional en Argentina 🇦🇷
      </div>

      <h1 className="text-4xl md:text-6xl font-extrabold leading-tight mb-6" data-id="element-122">
        Todo tu año de Entrenamiento Funcional.
        <br data-id="element-123" />
        <span className="text-primary" data-id="element-124">Listo. Desde hoy.</span>
      </h1>

      <div className="my-10 flex justify-center" data-id="element-125">
        <img src="https://cdn.magicpatterns.com/uploads/2ymYcyVeknqTD4GdDGYRQy/combo_completo_e.funcional_2_sin_fondo.png" alt="Combo Completo de Entrenamiento Funcional — 6 Tomos + Bonos" className="w-full max-w-[700px] aspect-square object-contain drop-shadow-[0_0_40px_rgba(74,222,128,0.15)]" data-id="element-126" />
      </div>

      <p className="text-xl md:text-2xl text-zinc-400 mb-8 max-w-2xl mx-auto font-medium" data-id="element-127">
        COMBO COMPLETO DE E. FUNCIONAL — 6 Tomos + 6 Bonos
      </p>

      <p className="text-lg text-zinc-300 mb-10 max-w-3xl mx-auto" data-id="element-128">
        240 clases listas · Progresión anual · Sin planificar · Sin improvisar
      </p>

      <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-10 text-sm md:text-base text-zinc-300" data-id="element-129">
        <div className="flex items-center gap-2" data-id="element-130">
          <FileText className="w-4 h-4 text-primary" data-id="element-131" /> 100% PDF
        </div>
        <div className="flex items-center gap-2" data-id="element-132">
          <Clock className="w-4 h-4 text-primary" data-id="element-133" /> Acceso en 5 min
        </div>
        <div className="flex items-center gap-2" data-id="element-134">
          <Calendar className="w-4 h-4 text-primary" data-id="element-135" /> 48 semanas
        </div>
        <div className="flex items-center gap-2" data-id="element-136">
          <CheckCircle2 className="w-4 h-4 text-primary" data-id="element-137" /> 240 clases
        </div>
        <div className="flex items-center gap-2" data-id="element-138">
          <Package className="w-4 h-4 text-primary" data-id="element-139" /> 6 Tomos + 6 Bonos
        </div>
      </div>

      <Button href="https://www.compradigitalya.com/checkouts/cn/hWNBfCDdHQUTNK8tIikCUts2/es-ar?_r=AQAB1bvEcqlGPcyGyamgvjBgxYvtyuUNQZ9h35zPIFBVk78&cart_link_id=nZEWN4Xd&preview_theme_id=141062045767" className="text-xl md:text-2xl py-5 px-8 w-full md:w-auto mb-6" data-id="element-140">
        🏋️ QUIERO MI COMBO COMPLETO AHORA
      </Button>

      <div className="flex flex-wrap justify-center gap-4 text-sm text-zinc-400 font-medium" data-id="element-141">
        <span className="flex items-center gap-1" data-id="element-142">🛡️ Garantía 7 días</span>
        <span className="hidden md:inline text-zinc-700" data-id="element-143">|</span>
        <span className="flex items-center gap-1" data-id="element-144">🔒 Pago seguro</span>
        <span className="hidden md:inline text-zinc-700" data-id="element-145">|</span>
        <span className="flex items-center gap-1" data-id="element-146">💳 Mercado Pago</span>
      </div>
    </section>;
}